@switch (columnName) {
  @case ('dateTime') {
    {{ element['date'] | date: dateFormat }}
  }
  @case ('action') {
    {{ element['workVersionReason'] | lowercase | translate }}
  }
  @case ('actionDoneBy') {
    <div class="row align-items-center">
      <mat-icon>perm_identity</mat-icon>
      <p class="text">{{ element['by'] }}</p>
    </div>
  }
  @case ('taskLogDetails') {
    <div class="task-log-details">
      <div class="changes mb-05">
        @if (element.workVersionReason === taskActionTypes.Perform) {
          {{ 'performedWithXParticipants' | translate: { participantsCount: element['details'] } }}
        }
        @if (element.workVersionReason === taskActionTypes.Postpone) {
          <div class="column">
            <p>
              {{ 'postponed' | translate }}
              @if (element?.details?.oldValue) {
                &nbsp;{{ 'from' | translate | lowercase }}
              }
              {{ element?.details?.oldValue | date }}
              @if (element?.details?.newValue) {
                &nbsp;{{ 'to' | translate | lowercase }}
              }
              {{ element?.details?.newValue | date }}
            </p>
            <p>{{ element?.details?.comment }}</p>
          </div>
        }
      </div>
      <div class="comment mb-05">{{ element.comment }}</div>
      <div class="description">{{ element.description }}</div>
    </div>
  }
  @case ('view') {
    @if (element.workVersionReason === taskActionTypes.Perform) {
      <app-ui-button
        buttonType="secondary"
        text="{{ 'view' | translate }}"
        [routerLink]="performViewRoute + '/' + element['taskId'] + '/' + element['workVersionId']"
      ></app-ui-button>
    }
  }
  @case ('legacyAttachment') {
    @if (element.attachment) {
      @if (element.attachment.id !== 'new') {
        <a [href]="element.attachment.link" target="_blank" [download]="element.attachment.name">
          <mat-icon class="download-icon">download</mat-icon>
        </a>
      }
    }
  }
  @case ('attachments') {
    @if (element.attachmentsCount) {
      <div class="attachments-preview" (click)="openAttachments()">
        {{ element.attachmentsCount }}
        <mat-icon class="download-icon">attach_file</mat-icon>
      </div>
    }
  }
  @case ('trip') {
    {{ element?.trip?.name }}
  }
  @case ('haccpBy') {
    <div class="haccp-date">
      {{ element['haccpDate'] | date }} •
      <span class="haccp-time">{{ element['haccpDate'] | date: timeFormat }}</span>
    </div>
    {{ element['haccpBy'] }}
  }
  @default {
    <app-default-cell
      [element]="element"
      [columnName]="columnName"
      [parseLinks]="!!element.haccpId"
    ></app-default-cell>
  }
}
